export default __webpack_public_path__ + "static/media/Cancel.171c8e47.svg";